import { ToWords } from 'to-words';

/** Convert a number to an alphabetic character
 *
 * ex: 0 -> 'A'
 *
 * ex: 1 -> 'B'
 */
export function convertNumberToAlpha(num: number): string {
  return String.fromCharCode(65 + num);
}

/**
 * Formats a number to a currency string with commas and a dollar sign.
 *
 * ex: 123456789 -> '$123,456,789'
 */
export function formatCurrency(value: number): string {
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);

  return formattedValue;
}

export const formatStripePlanPrice = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amount / 100);
};

export const formatStripePlanInterval = (interval: string, intervalCount: number): string => {
  if (intervalCount === 1) {
    return `per ${interval}`;
  }

  return `/${intervalCount} ${interval}s`;
};

/**
 * Converts a number to its word representation (optionally lowercase).
 *
 * ex: 3 -> 'three'
 */
export function numberToWords(value: number, lowercase = true): string {
  const toWords = new ToWords();

  return lowercase ? toWords.convert(value).toLowerCase() : toWords.convert(value);
}

/**
 * Formats a phone number to a standard format.
 *
 * ex: 1234567890 -> '(123) 456-7890'
 */
export const formatPhoneNumber = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  return phone;
};
